import React, { useState } from 'react';
import ViewFilterButton from '../../../../../components/ProTable/ViewFilterButton';
import { useSelector } from 'react-redux';
import { getFilter } from '../../../../../stores/algos-list/getters';
import { updateFilter } from '../../../../../stores/algos-list/actions';
import useBrokerDataAll from '../../../../../hooks/useBrokerDataAll';
import ViewFilterModalDecorated from '../../../../../components/ProTable/ViewFilterModalDecorated';

function useOptions() {
  const brokersDataAll = useBrokerDataAll();

  const options = [
    {
      label: 'No broker selected',
      value: undefined,
    },
    ...brokersDataAll,
  ];

  return options;
}

const ViewBroker = () => {
  const [open, setOpen] = useState(false);
  const viewsFilter = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });
  const isViewActive = viewsFilter.broker ? true : false;
  const options = useOptions();

  function onOpen() {
    setOpen(true);
  }

  function onClose() {
    setOpen(false);
  }

  return (
    <>
      <ViewFilterButton onClick={onOpen} isActive={isViewActive} />
      {open ? (
        <ViewFilterModalDecorated
          open={open}
          onClose={onClose}
          updateFilter={updateFilter}
          options={options}
          viewsFilter={viewsFilter}
          fieldName="broker"
          title="Filter Client ID / Broker:"
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ViewBroker;
